import { useState } from 'react';

export const useModalState = (initialState = false) => {
  const [is, setIs] = useState(initialState);
  const show = () => setIs(true);
  const hide = () => setIs(false);

  return { is, show, hide };
};
